import {
  getAmountInCurrencyFormat,
  limitNumber,
  limitWeightTo,
} from "../../utils/number";

export default function LedgerKPI({ stats = {} }) {
  const { amount, gold, silver } = stats;

  const netAmount = amount?.value,
    netAmountType = amount?.type;
  const netGoldWeight = gold?.weight,
    netGoldType = gold?.type;
  const netSilverWeight = silver?.weight,
    netSilverType = silver?.type;

  return (
    <div className="kpi-grid">
      <KPICard
        label="Net Amount"
        value={netAmount}
        unit="PKR"
        type={netAmountType}
      />
      <KPICard
        label="Net Gold Weight"
        value={netGoldWeight}
        unit="g"
        type={netGoldType}
      />
      <KPICard
        label="Net Silver Weight"
        value={netSilverWeight}
        unit="g"
        type={netSilverType}
      />
    </div>
  );
}

function KPICard({ label, value, unit, type }) {
  const config = {
    settled: {
      card: "kpi-settled",
      badge: "badge-settled",
      icon: "fa-circle-check",
      label: "Settled",
    },
    receivable: {
      card: "kpi-receivable",
      badge: "badge-receivable",
      icon: "fa-circle-exclamation",
      label: "Receivable",
    },
    payable: {
      card: "kpi-payable",
      badge: "badge-payable",
      icon: "fa-circle-xmark",
      label: "Payable",
    },
  };
  const {
    card,
    badge,
    icon,
    label: badgeLabel,
  } = config[type] || config.settled;

  return (
    <div className={`kpi-card ${card}`}>
      <div className="kpi-divider" />
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">
        {unit === "PKR"
          ? getAmountInCurrencyFormat(value)
          : limitWeightTo(value)}
        <span className="kpi-unit">{unit}</span>
      </div>
      <div className={`kpi-badge ${badge}`}>
        <i className={`fas ${icon}`} style={{ fontSize: 10 }}></i>
        {badgeLabel}
      </div>
    </div>
  );
}
